import { fabric } from 'fabric';
import { CanvasDataTypes, getGroupedItemByName } from '../../../utils/canvas-utils';
import { handleTemporaryTextEditor } from './handle-temporary-text-editor';

/**
 * Handler for when mouse target on canvas is a photoTextzone
 * @param photoTextZone selected phototextzone
 * @param canvas
 */
type HandlePhototextzoneSelectionProps = {
  photoTextZone: fabric.Group;
  canvas: fabric.Canvas;
};

export const handlePhototextzoneSelection = ({ photoTextZone, canvas }: HandlePhototextzoneSelectionProps): void => {
  const groupedItem = getGroupedItemByName(CanvasDataTypes.PhotoZoneTextbox, photoTextZone);
  const originalText = groupedItem instanceof fabric.Textbox ? groupedItem : undefined;
  // if the photoTextZone has text, handle temporary text editor to edit the text
  if (originalText?.text) {
    handleTemporaryTextEditor({
      currentCanvas: canvas,
      zone: photoTextZone,
    });
  }
};
